window.setupTemplateUtils = () => {
  return {
    setSourceMarker(props) {
      props.src = props.src || 'flex';
      // selector example = '.npaddlinks a'
      // the props argument is an object holding values for selector, "%%PATTERN:pos%%" and "_%%SITE%%"
      const srcLinks = document.querySelectorAll(props.selector);
      const marker = props.site != '' ? `src=${props.src}_${props.pos}_${props.site}` : (props.pos ? `src=${props.src}_${props.pos}` : `src=${props.src}`);
      var adUrlRegex = new RegExp('adurl(?:%253D|=)');
      var domainsArray = [ "medscape", "mdedge", "mdalert", "univadis", "coliquio", "jim" ];

      Array.prototype.forEach.call(srcLinks, (link, i)=> {
        var url = link.href;

        var lowercaseDomainToCheck = url.toLowerCase();
        var containsSpecificDomain = domainsArray.some(domain => lowercaseDomainToCheck.includes(domain));

        if (url.search(adUrlRegex) != -1) {
          url = url.split(adUrlRegex)[1];
        }
        if (url != "" && containsSpecificDomain) {
          var arr = url.split('%3F');
          if (url.length > 1 && arr[1] != undefined && arr[1] != '' && (arr[1].indexOf("%3D") != -1)) {
            link.href += "&" + marker;
          } else if (url.length > 1) {
            link.href += "?" + marker;
          }
        }
      })
    }
  }
}
